export function toJalaliDateTime(timestampSec) {
  const tsSec = Number(timestampSec || 0);
  const dt = new Date(tsSec * 1000);
  const fmt = new Intl.DateTimeFormat("fa-IR", {
    timeZone: "Asia/Tehran",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
  return fmt.format(dt);
}
